import * as types from './types';
import { loading } from 'State/actions';

export const getEnrollmentDetails = siteId => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SITESETUP_ENROLLMENT_FETCHING, true));

    try {
      const response = await MPWWebApi.getGeneric(
        `sitemaster/Enrollment/${siteId}`
      );
      dispatch({
        type: types.SITESETUP_GET_ENROLLMENT_DETAILS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: types.SITESETUP_GET_ENROLLMENT_DETAILS_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.SITESETUP_ENROLLMENT_FETCHING, false));
  };
};



// WEBPACK FOOTER //
// ./src/pages/sitesetup/state/enrollment/actions.js